const mainPage = document.querySelector('virtual-tour#map');
document.addEventListener('DOMContentLoaded', () => {
  mainPage.parentElement.classList.add('front', 'active');
  document.querySelectorAll('.virtual-tour-main')[1].classList.add('previous');
  document.querySelectorAll('.vt-wrapper').forEach(e => {
    scrollToCenter(e);
  })
  setTimeout(() => {
    mainPage.classList.remove('loading');
  }, 2000);
  window.scrollTo(0,1);
});


function scrollToCenter(element) {
  // const wrapper = mainPage.querySelector('.vt-wrapper');
  const scrollLeft = (element.scrollWidth - element.clientWidth) / 2;
  element.scrollLeft = scrollLeft;
}


if (!customElements.get('virtual-tour')) {
  class VirtualTour extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        this.handleClick(event);
      })


  this.scrollContainer = this.querySelector('.vt-wrapper');

  let isDown = false;
  let startX, startY;
  let scrollLeft, scrollTop;
  
 this.scrollContainer.addEventListener('mousedown', (e) => {
      isDown = true;
     this.scrollContainer.classList.add('active');
     this.scrollContainer.style.cursor = 'grabbing';
      startX = e.pageX -this.scrollContainer.offsetLeft;
      startY = e.pageY -this.scrollContainer.offsetTop;
      scrollLeft =this.scrollContainer.scrollLeft;
      scrollTop =this.scrollContainer.scrollTop;
  });
  
 this.scrollContainer.addEventListener('mouseleave', () => {
      isDown = false;
     this.scrollContainer.style.cursor = 'grab';
  });
  
 this.scrollContainer.addEventListener('mouseup', () => {
      isDown = false;
     this.scrollContainer.style.cursor = 'grab';
  });
  
 this.scrollContainer.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX -this.scrollContainer.offsetLeft;
      const y = e.pageY -this.scrollContainer.offsetTop;
      const walkX = (x - startX) * 2; // adjust scroll speed here
      const walkY = (y - startY) * 2; // adjust scroll speed here
     this.scrollContainer.scrollLeft = scrollLeft - walkX;
     this.scrollContainer.scrollTop = scrollTop - walkY;
  });
    }

    handleClick(evt) {
      const button = evt.target.closest('button');

      if (button && button.classList.contains('vt-link--button')) {
        if(button.id == 'about-store'){
          this.viewAbout(button.dataset.id);
        }
        else{
          const page = button.dataset.link;
          this.showPage(page)
        }
      }
      if (button && button.id == 'view-map') {
        this.viewMap();
      }
      if (button && button.id == 'about-store') {
        this.viewAbout(button.dataset.id);
      }
      if (button && button.classList.contains('vt-about--close')) {
        this.closeAbout();
      }
      if (button && button.classList.contains('vt-map--close')) {
        this.closeMap();
      }
    }

    async showPage(param) {
      const page = document.querySelector(`virtual-tour#${param}`);
      page.parentElement.classList.contains('previous.active') ? '' : page.classList.add('loading');
      await this.fadeOut(this.parentElement);
      page.parentElement.classList.add('front', 'active');
      setTimeout(() => {
        page.classList.remove('loading');
      }, 1000)
      console.log(this.id, this)
      if (page.id != 'map') {
        document.querySelector('.previous').classList.remove('previous');
        page.parentElement.classList.add('previous');
      }
      this.scrollToCenter(page.querySelector('.vt-wrapper'))
    }

    async viewMap() {
      await this.fadeOut(this.parentElement);
      mainPage.parentElement.classList.add('front', 'active', 'show-close');
      mainPage.classList.add('show-close');
      this.scrollToCenter(mainPage.querySelector('.vt-wrapper'))
    }

    closeMap() {
      mainPage.parentElement.classList.remove('front', 'active');
      document.querySelector('.previous').classList.add('front', 'active');
    }
    
    viewAbout(id){
      this.querySelector(`.vt-about[data-id="${id}"]`).classList.add('show')
    }
    
    scrollToCenter(element) {
      // const wrapper = mainPage.querySelector('.vt-wrapper');
      const scrollLeft = (element.scrollWidth - element.clientWidth) / 2;
      element.scrollLeft = scrollLeft;
    }

    closeAbout(){
      this.querySelector('.vt-about.show').classList.remove('show')
    }
    async fadeOut(element) {
      element.classList.remove('front');
      // return new Promise((resolve) => {
      //   setTimeout(() => {
          element.classList.remove('active');
      //     resolve();
      //   }, 500);
      // });
    }

  }

  customElements.define('virtual-tour', VirtualTour);
}